export const iconFontAwesomeTransportationCableCar = (
	<i className="fa-solid fa-cable-car"></i>
);
